import { useMemo } from 'react'
import { useGetBusinessProfile, IAssigneeOptions } from 'appHooks/useGetBusinessProfile'
import { BusinessUserType, useGetAdvisorDashboardQuery } from '__generated__/api-types-and-hooks'

interface IUseAssigneeOptionsProps {
  isAdvisor: boolean
  tenantId: string
}

export const useAssigneeOptions = ({ isAdvisor, tenantId }: IUseAssigneeOptionsProps) => {
  // Get business profile to access team members
  const { assigneeOptions: businessAssigneeOptions } = useGetBusinessProfile({ enabled: true })

  // Get advisor dashboard data to fetch all clients (Business Owners)
  const { data: advisorData } = useGetAdvisorDashboardQuery(
    { tenantId },
    {
      refetchOnWindowFocus: false,
      enabled: isAdvisor,
    }
  )

  // Combine assignee options based on user role
  const assigneeOptions: IAssigneeOptions[] = useMemo(() => {
    let options: IAssigneeOptions[] = []

    if (!isAdvisor) {
      // For business owners, show team members
      options = businessAssigneeOptions || []
    } else {
      // For advisors, show all their clients (Business Owners)
      const response = JSON.parse(advisorData?.getAdvisorDashboard?.data || '{}')
      options =
        response?.accounts?.map((account: any) => ({
          label: `${account?.firstName} ${account?.lastName}`,
          value: account?.id,
          type: BusinessUserType.Member,
          user: {
            id: account?.id,
            firstName: account?.firstName,
            lastName: account?.lastName,
          },
        })) || []
    }

    return options
  }, [isAdvisor, businessAssigneeOptions, advisorData])

  return assigneeOptions
}
